module.exports = __webpack_public_path__ + "assets/img/exclusive-gateway.7eb1f01e.svg";